/* eslint-disable import/order */
import { MenuIdSettings } from '@jira/navigation-apps__constants/src/MenuIdSettings.tsx';
import { SidebarIdGlobalProductsSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalProductsSettings.tsx';
import { LazyAtlassianNavigation } from '@jira/navigation-apps__atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import {
	getNavigationResources,
	getNavigationSidebarProductsSettingResource,
} from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { productsJswConfigurationResource } from '@jira/router-resources__products-jsw-configuration/src/productsJswConfigurationResource.tsx';
import { productsJswConfigurationRoute } from '@jira/router-routes__products-jsw-configuration-routes/src/productsJswConfigurationRoute.tsx';
import ProductsJswConfiguration, { LazyProductsJswConfiguration } from './ui/index.tsx';
import type { Route } from '@atlassian/react-resource-router';

export const productsJswConfigurationRouteEntry: Route = createEntry(
	productsJswConfigurationRoute,
	() => ({
		group: 'global-settings',
		ufoName: 'admin.jsw-configuration',
		// eslint-disable-next-line no-restricted-syntax
		component: ProductsJswConfiguration,
		layout: globalSettingsLayout,

		navigation: {
			sidebarId: SidebarIdGlobalProductsSettings,
			menuId: MenuIdSettings,
		},

		resources: [
			...getNavigationResources(),
			...getNavigationSidebarProductsSettingResource(),
			productsJswConfigurationResource,
		],

		forPaint: [LazyAtlassianNavigation, LazyProductsJswConfiguration],

		bifrost: {
			bifrostGroup: 'shell-only',
		},
	}),
);
